module.exports = __webpack_public_path__ + "static/iemas-89c3463a4057319fc6e0116fb458a91b.svg";